/* ILS platform: accessible navigation, enquiry context, consent-gated event hooks. */
(() => {
  if (window.ILSPlatform) return;
  // Shopify's privacy API must be loaded explicitly; loading it does not grant consent.
  const privacyReady = new Promise(resolve => {
    let attempts = 0;
    const loadPrivacy = () => {
      if (window.Shopify?.customerPrivacy) { resolve(true); return; }
      if (window.Shopify?.loadFeatures) {
        window.Shopify.loadFeatures([{ name:'consent-tracking-api', version:'0.1' }], error => resolve(!error));
      } else if (++attempts < 100) setTimeout(loadPrivacy, 100);
      else resolve(false);
    };
    loadPrivacy();
  });
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const attributionAllowed = () => window.Shopify?.customerPrivacy?.marketingAllowed?.() === true;
  const acquisition = window.ILSAttributionCore;
  const campaignKey = 'ils_campaign_v1';
  function captureCampaign() {
    if (!acquisition) return;
    try {
      if (!attributionAllowed()) { sessionStorage.removeItem(campaignKey); return; }
      const data = acquisition.campaign(location.search, location.pathname);
      if (data) sessionStorage.setItem(campaignKey, JSON.stringify(data));
    } catch (_) {}
  }
  function currentCampaign() {
    if (!acquisition || !attributionAllowed()) return null;
    try { return acquisition.record(JSON.parse(sessionStorage.getItem(campaignKey) || 'null')); } catch (_) { return null; }
  }
  function campaignFields(form) {
    form.querySelectorAll('[data-attribution]').forEach(input => input.remove());
    const data = currentCampaign();
    if (!data) return;
    for (const key of [...acquisition.keys, 'landingPath']) {
      if (!data[key]) continue;
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = `contact[${key === 'landingPath' ? 'Campaign landing page' : key}]`;
      input.dataset.attribution = key; input.value = data[key]; form.append(input);
    }
  }
  privacyReady.then(() => { captureCampaign(); document.querySelectorAll('.it-native-enquiry').forEach(campaignFields); });
  document.addEventListener('visitorConsentCollected', () => { captureCampaign(); document.querySelectorAll('.it-native-enquiry').forEach(campaignFields); });
  function emit(name, data = {}) {
    if (!allowed()) return;
    // No names, emails, phone numbers, free text or search terms enter analytics.
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...data });
    window.Shopify?.analytics?.publish?.(name, data);
  }
  window.ILSPlatform = { emit, analyticsAllowed: allowed };
  // Shopify's existing banner owns the choices and consent signals.
  document.querySelectorAll('[data-privacy-choices]').forEach(button => {
    button.hidden = false;
    button.addEventListener('click', async () => {
      const status = document.querySelector('[data-privacy-status]');
      button.disabled = true;
      if (status) status.textContent = '';
      try {
        await privacyReady;
        for (let attempt = 0; attempt < 10 && !window.privacyBanner?.showPreferences; attempt++) {
          await new Promise(resolve => setTimeout(resolve, 500));
        }
        if (!window.privacyBanner?.showPreferences) throw new Error('Preferences unavailable');
        await window.privacyBanner.showPreferences();
      } catch (_) {
        if (status) status.textContent = 'Privacy preferences could not open. Please try again or read the privacy policy.';
      } finally {
        button.disabled = false;
      }
    });
  });
  // Label asynchronously inserted quote controls without changing app behaviour.
  const shortlist = document.querySelector('.rfq_form_page');
  if (shortlist) {
    const labelQuoteControls = () => {
      const country = shortlist.querySelector('select[name="shipping_address[country]"]');
      if (country && !country.dataset.ilsInitialised) {
        country.dataset.ilsInitialised = 'true';
        // The app otherwise chooses its first alphabetical option, Ascension Island.
        // Preserve saved/customer addresses and any explicit selection.
        const hasSavedDetails = shortlist.querySelector('[name="contact_info[email]"]')?.value || shortlist.querySelector('[name="shipping_address[address1]"]')?.value;
        if (!hasSavedDetails && country.selectedIndex === 0 && country.value === 'AC' && !country.querySelector('option[selected]')) {
          country.value = 'GB';
          country.dispatchEvent(new Event('change', { bubbles:true }));
        }
      }
      shortlist.querySelectorAll('.grfq-product-item').forEach(row => {
      const title = row.querySelector('.grfq-product-title a')?.textContent.trim() || 'machine';
      row.querySelectorAll('.grfq-variant-quantity-icon > button').forEach(button => {
        if (!button.hasAttribute('aria-label')) button.setAttribute('aria-label', `Remove ${title} from quote`);
      });
      row.querySelectorAll('input[type="number"], input.grfq-item-quantity-input').forEach(input => {
        if (!input.hasAttribute('aria-label')) input.setAttribute('aria-label', `Quantity for ${title}`);
      });
      });
    };
    labelQuoteControls();
    new MutationObserver(labelQuoteControls).observe(shortlist, { childList:true, subtree:true });
  }
  let appQuoteReported = false;
  document.addEventListener('GRFQ_form_submitted', () => {
    privacyReady.then(() => {
      if (!appQuoteReported && allowed()) { appQuoteReported = true; emit('quote_submit', { form_type:'machine_shortlist' }); }
    });
  });
  const menus = document.querySelectorAll('.it-nav-links details, .it-mobile, .it-header-search');
  menus.forEach(menu => menu.addEventListener('toggle', () => {
    if (menu.open) menus.forEach(other => { if (other !== menu) other.open = false; });
  }));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') menus.forEach(menu => { if (menu.open) { menu.open = false; menu.querySelector('summary').focus(); } }); });
  document.addEventListener('click', e => {
    if (!e.target.closest('.it-nav')) menus.forEach(menu => { menu.open = false; });
    const link = e.target.closest('a[href]');
    if (!link) return;
    const href = link.getAttribute('href');
    if (acquisition && href) {
      try {
        const target = new URL(href, location.origin);
        const source = acquisition.publicPath(location.pathname);
        if (target.origin === location.origin && ['/pages/contact', '/pages/request-a-quote'].includes(target.pathname) && source && !target.searchParams.has('source')) {
          target.searchParams.set('source', source); link.href = target.href;
        }
      } catch (_) {}
    }
    if (href.startsWith('tel:')) emit('phone_click', { location: link.closest('header') ? 'header' : 'page' });
    else if (href.startsWith('mailto:')) emit('email_click');
    else if (/\.pdf(?:\?|$)/i.test(href)) emit('document_download', { page_type: document.querySelector('main')?.dataset.template || '' });
  });
  const params = new URLSearchParams(location.search);
  document.querySelectorAll('.it-native-enquiry').forEach(form => {
    const purpose = form.querySelector('[data-enquiry-intent]');
    const intent = (params.get('intent') || params.get('enquiry') || '').toLowerCase();
    const aliases = { equipment:'Equipment', repair:'Repair', repairs:'Repair', maintenance:'Maintenance', parts:'Parts', project:'Project', other:'Other' };
    if (purpose && aliases[intent]) purpose.value = aliases[intent];
    const product = form.querySelector('[data-enquiry-product]');
    const productText = params.get('product') || params.get('model');
    const partReference = params.get('sku') || params.get('part');
    if (product && (productText || partReference)) {
      product.value = [productText?.slice(0, 300), partReference?.slice(0, 100)].filter(Boolean).join(' / ');
      const details = product.closest('details'); if (details) details.open = true;
      if (purpose && !purpose.value) purpose.value = partReference ? 'Parts' : 'Equipment';
    }
    const sourceInput = form.querySelector('[data-enquiry-source]');
    const source = acquisition?.publicPath(params.get('source') || '');
    if (sourceInput && source) sourceInput.value = new URL(source, location.origin).href;
    const variantInput = form.querySelector('[data-enquiry-variant]');
    const variant = params.get('variant') || '';
    if (variantInput && /^\d{1,25}$/.test(variant)) variantInput.value = variant;
    let started = false;
    form.addEventListener('input', () => { if (!started && allowed()) { started = true; emit('quote_start', { form_type:'native_enquiry' }); } });
    // Carry only consented, sanitised campaign values within this browser tab.
    form.addEventListener('submit', () => {
      captureCampaign(); campaignFields(form);
      if (!allowed()) return;
      try { sessionStorage.setItem('ils_pending_enquiry', JSON.stringify({ at:Date.now(), intent:purpose?.value || 'Other' })); } catch (_) { /* Storage restrictions must never block an enquiry. */ }
    });
    if (form.querySelector('[data-enquiry-success]')) {
      form.querySelector('[data-enquiry-success]').focus();
      // Consume a consented submission once: a reload must not inflate conversions.
      privacyReady.then(() => { try {
        const pending = JSON.parse(sessionStorage.getItem('ils_pending_enquiry') || 'null');
        if (pending && Date.now() - pending.at < 3600000 && allowed()) {
          sessionStorage.removeItem('ils_pending_enquiry');
          emit('quote_submit', { form_type:'native_enquiry', intent:pending.intent });
          if (pending.intent === 'Repair') emit('repair_enquiry', { form_type:'native_enquiry' });
          if (pending.intent === 'Maintenance') emit('service_enquiry', { form_type:'native_enquiry' });
        }
      } catch (_) { /* Functional success remains visible if storage is unavailable. */ } });
    }
    const error = form.querySelector('.it-form-error'); if (error) error.focus();
  });
})();
